/**
 * Shared visual tokens for the personal Monitor app (`/app/*`).
 *
 * Self-contained inline styling (matching the `/monitor/*` page convention)
 * so the consumer app reads as its own friendly product, independent of the
 * operator shell's Tailwind theme.
 */

export const c = {
  ink: '#0f172a',
  inkMuted: '#475569',
  inkSubtle: '#64748b',
  rim: '#e2e8f0',
  canvas: '#f8fafc',
  surface: '#ffffff',
  accent: '#1d4ed8',
  accentSoft: '#eff6ff',
  good: '#15803d',
  goodSoft: '#f0fdf4',
  goodRim: '#bbf7d0',
  warn: '#b45309',
  warnSoft: '#fffbeb',
  warnRim: '#fde68a',
  danger: '#b91c1c',
  dangerSoft: '#fef2f2',
  dangerRim: '#fecaca',
} as const;

export const font =
  'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
